import * as yup from 'yup';

import { ErrorMessages } from '@constants/common/messages.constants';

const MAX_LENGTH = 2048;

const DEX_SCREENER_URL_PATTERN = /^https:\/\/dexscreener\.com\/?.*$/;

export const requestFarmYup = yup
  .string()
  .trim()
  .required(ErrorMessages.Required)
  .url(ErrorMessages.InvalidUrl)
  .max(MAX_LENGTH, ({ max }) =>
    ErrorMessages.MaxLengthExceeded.replace('[max]', String(max)),
  )
  .matches(DEX_SCREENER_URL_PATTERN, ErrorMessages.InvalidUrl);
